const UMLAUT_LOOKUP = {
  ae: "ae",
  oe: "oe",
  ue: "ue",
  ss: "ss",
  ä: "ae",
  ö: "oe",
  ü: "ue",
  ß: "ss",
};

export function slugify(value) {
  return value
    .toLowerCase()
    .replace(/[äöüß]/g, (character) => UMLAUT_LOOKUP[character] || character)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function withLocale(path, locale) {
  return locale && locale !== "de" ? `/${locale}${path}` : path;
}

export function getImagePagePath(image, locale) {
  if (locale && image.seoPaths?.[locale]) {
    return image.seoPaths[locale];
  }

  if (image.seoPath) {
    return withLocale(image.seoPath, locale);
  }

  if (image.seoSlug) {
    return withLocale(`/ausmalbild/${image.seoSlug}`, locale);
  }

  return withLocale(`/view/${image.downloadUrl.replace(".png", "")}`, locale);
}
